import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AI_MODELS_BY_ROLE_ACTION_TYPE } from '../actions/aiModelsByRole.actions';

const initialState = {
  byKey: {},
  loadingByKey: {},
  errorByKey: {},
};

const aiModelsByRoleReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AI_MODELS_BY_ROLE_ACTION_TYPE.GET_AI_MODELS_BY_ROLE_REQUEST:
        draft.loadingByKey[payload.key] = true;
        draft.errorByKey[payload.key] = null;
        break;

      case AI_MODELS_BY_ROLE_ACTION_TYPE.GET_AI_MODELS_BY_ROLE_SUCCESS:
        draft.byKey[payload.key] = payload.models;
        draft.loadingByKey[payload.key] = false;
        break;

      case AI_MODELS_BY_ROLE_ACTION_TYPE.GET_AI_MODELS_BY_ROLE_FAILURE:
        draft.loadingByKey[payload.key] = false;
        draft.errorByKey[payload.key] = payload.error;
        break;

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default aiModelsByRoleReducer;
